export const getLocale = (state) => state.localization.locale;